import React, { useState, JSX } from 'react';
import { Col, Row } from 'reactstrap';
import { sanitize } from '@ibe/services';
import { ApiItinerary } from '@ibe/api';
import Keys from '../../../_Translations/generated/package-details.en.t.json.keys';
import fallback from '../../../_Translations/generated/package-details.en.t.json';
import useTranslation from '../../Hooks/useTranslation';
import CarouselComponent from './CarouselComponent';

interface Props {
  itineraries?: ApiItinerary[];
  isSmall: boolean;
}

const ItineraryContent = (props: Props): JSX.Element => {
  const { itineraries, isSmall } = props;
  const { t } = useTranslation('package-details', fallback, Keys);

  const [activeDayId, setActiveDayId] = useState(0);

  const items = itineraries && itineraries[activeDayId];

  const imageToDisplay = items?.mainImage?.large || items?.mainImage?.small || null;
  const longDescription = items?.longDescription || '';

  return (
    <div className="itinerary">
      <Col>
        <Row className="mb-1">
          <CarouselComponent
            activeDayId={activeDayId}
            setActiveDayId={setActiveDayId}
            isSmall={isSmall}
            itineraries={itineraries}
          />
        </Row>
        <Row>
          <span className="itinerary__day"> {`${t(Keys.day)} ${activeDayId + 1}`} </span>
        </Row>
        <Row>
          <span className="itinerary__title"> {itineraries && items?.title} </span>
        </Row>
        <Row>
          <div
            className="text-muted"
            dangerouslySetInnerHTML={{ __html: sanitize(longDescription) }}
          />
        </Row>
        {imageToDisplay && <hr />}
        <Row className="my-3">
          {imageToDisplay && (
            <Col className="col-12 d-flex justify-content-center">
              <img
                className="d-block img-fluid"
                src={imageToDisplay?.url}
                alt={t(Keys.previewExample)}
              />
            </Col>
          )}
        </Row>
      </Col>
    </div>
  );
};

export default ItineraryContent;
